export const SearchResultPageId = 'SearchResultPage';

export enum SearchPageAttributes {
  FILTERS = 'filters',
}
